import { combineReducers } from "redux";
import user from "reactRedux/reducer/userReducer";
import example from "reactRedux/reducer/exampleReducer1";

export default combineReducers({
    user, example
});